import { Routes } from '@angular/router';
import { IsLoggedInGuard } from './shared/utils/guards/isLoggedIn/is-logged-in.guard';
import { AuthShellComponent } from './auth/ui/auth-shell/auth-shell.component';
import { OnboardingShellComponent } from './onboarding/ui/onboarding-shell/onboarding-shell.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { DashboardShellComponent } from './shared/ui/dashboard-shell/dashboard-shell.component';
import { ServicesComponent } from './pages/services/services.component';
// import { ReportsPage } from './pages/reports/reports.page';

export const routes: Routes = [
  {
    path: '',
    component: DashboardShellComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/dashboard/dashboard.routes').then((m) => m.routes),
      },
      {
        path: 'payments',
        loadComponent: () =>
          import('./pages/payments/payments.page').then((m) => m.PaymentsPage),
      },
      {
        path: 'services',
        children: [
          {
            path: '',
            component: ServicesComponent,
          },
          {
            path: 'airtime-data',
            component: ServicesComponent,
          },
          {
            path: 'bills-utilities',
            component: ServicesComponent,
          },
        ],
      },
      {
        path: 'business',
        loadComponent: () =>
          import('./pages/settings/settings.page').then((m) => m.SettingsPage),
      },
      {
        path: 'insights',
        loadComponent: () =>
          import('./pages/insights/insights.page').then((m) => m.InsightsPage),
      },
      {
        path: 'reports',
        loadComponent: () =>
          import('./pages/reports/reports.page').then((m) => m.ReportsPage),
      },
    ],
    canActivate: [IsLoggedInGuard],
  },
  {
    path: 'auth',
    component: AuthShellComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./auth/auth.routes').then((m) => m.routes),
      },
    ],
  },
  // {
  //   path: '__/auth',
  //   component: AuthShellComponent,
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () => import('./auth/auth.routes').then((m) => m.routes),
  //     },
  //   ],
  // },
  {
    path: 'onboarding',
    component: OnboardingShellComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./onboarding/onboarding.routes').then((m) => m.routes),
      },
    ],
    canActivate: [IsLoggedInGuard],
  },
  {
    path: 'splash',
    loadComponent: () =>
      import('./shared/ui/splash-loader/splash-loader.component').then(
        (m) => m.SplashLoaderComponent,
      ),
  },

  { path: '**', component: PageNotFoundComponent },
];
